import { useEffect, useState } from 'react';
import { Container, Card, Form, Button, Spinner, Alert } from 'react-bootstrap';
import './PrevRegistrationManagement.css';
import { useForm } from 'react-hook-form';
import InputField from '../InputField';
import Toaster from '../../Toaster/Toaster';
import {
  useCheckPreviousRegistration,
  useCreatePreviousRegistration,
  usePreviousMatchOTP,
} from '../apiEndpoints/commApiEndpoints';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';
import { B2B_USER_SUCCESS } from '../../../Helpers/Constant';
import { useNavigate } from 'react-router-dom';
const Toast = Toaster();
const PrevRegistrationManagement = () => {
  const [step, setStep] = useState(1); // 1: check, 2: otp, 3: password
  const {
    mutate,
    isSuccess: checkSuc,
    isPending,
  } = useCheckPreviousRegistration();
  const {
    mutate: createMutate,
    isSuccess: createSuc,
    isPending: createPending,
    data,
  } = useCreatePreviousRegistration();
  const {
    mutate: otpMutate,
    isSuccess: matchSuc,
    isPending: matchPending,
  } = usePreviousMatchOTP();
  const { dispatch: authDispatch, setIsLoading } = B2BAuthContext();
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (createSuc && data) {
      authDispatch?.({
        type: B2B_USER_SUCCESS,
        payload: { ...(data?.data as any), token: data?.token },
      });

      localStorage.setItem('toab_fair', data?.token as string);
      setIsLoading?.(false);
      navigate('/b2b/profile');
    }
  }, [createSuc, data]);

  useEffect(() => {
    if (checkSuc) {
      setStep(2);
    }
    if (matchSuc) {
      setStep(3);
    }
  }, [checkSuc, matchSuc]);

  const onSubmit = async (value: any) => {
    //context loading
    setIsLoading?.(true);
    const { confirm_password, email, password, otp, ...data } = value || {};

    if (password !== confirm_password && step === 3) {
      Toast.fire({
        icon: 'error',
        title: `Password does not match`,
      });

      return;
    }

    if (data?.new_password?.length < 8 && step === 3) {
      Toast.fire({
        icon: 'error',
        title: `Password must be at least 8 characters`,
      });
      return;
    }

    switch (step) {
      case 1:
        mutate({ email, type: 'previous_b2b' });
        break;
      case 2:
        otpMutate({ email, type: 'previous_b2b', otp: otp?.trim() });
        break;
      case 3:
        createMutate({ email, type: 'b2b', password });
        break;

      default:
        break;
    }
  };
  return (
    <Container className='registration-check-container'>
      <div className='registration-check-card-wrapper'>
        <Card className='registration-check-card'>
          <Card.Body>
            <div className='text-center mb-4'>
              <h2 className='card-title'>
                {step === 2 && 'Verify OTP'}
                {step === 3 && 'Enter Password'}
              </h2>
              <p className='text-muted'>
                {step === 1 &&
                  'Enter your Email to check if you are registered'}
                {step === 2 && (
                  <Alert variant={'success'}>
                    We sent a 6-digit OTP code to your email
                  </Alert>
                )}
                {step === 3 && 'Please enter your password to continue'}
              </p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              {step === 1 && (
                <>
                  <InputField
                    label='Email'
                    register={register('email')}
                    type='email'
                    isRequired
                    placeholder='Enter Email'
                  />
                </>
              )}
              {step === 2 && (
                <>
                  <InputField
                    label='OTP Code'
                    register={register('otp')}
                    type='number'
                    isRequired
                    placeholder='Enter OTP Code'
                  />
                </>
              )}
              {step === 3 && (
                <>
                  <InputField
                    label='Password'
                    register={register('password')}
                    type='text'
                    isRequired
                    placeholder='Enter  password'
                  />
                  <InputField
                    label='Confirm Password'
                    register={register('confirm_password')}
                    type='text'
                    isRequired
                    placeholder='Enter confirm password'
                  />
                </>
              )}
              <Button
                variant='primary'
                type='submit'
                className='w-100 mt-3 submit-btn'
                disabled={createPending || matchPending || isPending}
              >
                {createPending || matchPending || isPending ? (
                  <Spinner
                    as='span'
                    animation='border'
                    size='sm'
                    role='status'
                    aria-hidden='true'
                  />
                ) : (
                  'Submit'
                )}
              </Button>
              {step > 1 && (
                <div className='text-center mt-3'>
                  <Button
                    variant='link'
                    onClick={() => setStep(step - 1)}
                    className='back-link'
                  >
                    Back
                  </Button>
                </div>
              )}{' '}
            </form>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default PrevRegistrationManagement;
